import React, { useCallback } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { changeMapLayout } from 'modules/search/actions/updateLayout';
import { getIsMapOpen, getLayout } from 'modules/search/selectors';
import { MapDisplayAction } from 'modules/search/types';
import Settings from 'Settings';
import { Button } from '@daedalus/atlas/Button';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity } from '@daedalus/core/src/analytics/types/Events';
export const MAP_TOGGLE_BUTTON_WIDTH = 146;
const MAP_TOGGLE_BUTTON_HEIGHT = 50;
const _exp = /*#__PURE__*/() => Flex.Row;
const _exp2 = /*#__PURE__*/() => () => `url(${Settings.get('CLIENT_ASSETS_ENDPOINT') as string}static/map_toggle_background.png)`;
const MapToggleWrapper = /*#__PURE__*/styled(_exp())({
  name: "MapToggleWrapper",
  class: "mg7oz5a",
  propsAsIs: true,
  vars: {
    "mg7oz5a-0": [_exp2()]
  }
});
const _exp7 = /*#__PURE__*/() => Button;
const ButtonWrapped = /*#__PURE__*/styled(_exp7())({
  name: "ButtonWrapped",
  class: "b1t4dndo",
  propsAsIs: true
});
const _exp8 = /*#__PURE__*/() => SkeletonLoader;
const SkeletonLoaderWrapper = /*#__PURE__*/styled(_exp8())({
  name: "SkeletonLoaderWrapper",
  class: "s1uweokv",
  propsAsIs: true
});
const mapToggleButtonMessage = defineMessages({
  hide: {
    id: 'map.hide',
    defaultMessage: 'hide map'
  },
  show: {
    id: 'map.show',
    defaultMessage: 'show map'
  }
});
export const MapToggle = () => {
  const dispatch = useDispatch();
  const {
    formatMessage
  } = useIntl();
  const layout = useSelector(getLayout);
  const {
    isDesktopMd,
    isDesktopLg
  } = useDeviceLayout();
  const mapHasSplitView = isDesktopMd || isDesktopLg;
  const isMapOpen = useSelector(getIsMapOpen);
  const buttonMessageLabel = isMapOpen ? 'hide' : 'show';
  const toggleMapLayout = useCallback(() => {
    if (isMapOpen) {
      dispatch(changeMapLayout(MapDisplayAction.HIDE, mapHasSplitView));
    } else {
      dispatch(changeMapLayout(MapDisplayAction.SHOW, mapHasSplitView));
    }
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.MapViewToggle,
      action: Action.Clicked
    }));
  }, [dispatch, isMapOpen, mapHasSplitView]);

  // added as layout can return undefined until syncStoreWithUrl has finished
  if (!layout) {
    return <SkeletonLoaderWrapper height={MAP_TOGGLE_BUTTON_HEIGHT} width={MAP_TOGGLE_BUTTON_WIDTH} marginTop={0} />;
  }
  return <MapToggleWrapper justifyContent="center">
      <ButtonWrapped dataId="MapToggleButton" variant="secondary" isFloating size="md" onClick={() => toggleMapLayout()}>
        {formatMessage(mapToggleButtonMessage[buttonMessageLabel])}
      </ButtonWrapped>
    </MapToggleWrapper>;
};

require("./MapToggleButton.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MapToggleButton.tsx");